(() => {
  if (window.OMOCardColorsPreviewInitialized) return;
  window.OMOCardColorsPreviewInitialized = true;

  const getCard = (element) =>
    element.closest('.card-wrapper');

  const getMainImage = (card) =>
    card?.querySelector('.card__media .media > img:first-of-type');

  const showPreview = (link) => {
    const previewUrl = link.dataset.omoCardPreviewImage;

    if (!previewUrl) return;

    const card = getCard(link);
    const image = getMainImage(card);

    if (!card || !image) return;

    if (!image.dataset.omoOriginalSrc) {
      image.dataset.omoOriginalSrc =
        image.getAttribute('src') || '';

      image.dataset.omoOriginalSrcset =
        image.getAttribute('srcset') || '';
    }

    /*
     * Remove srcset temporarily.
     * Otherwise the browser may keep choosing
     * the current product image from the old srcset.
     */
    image.removeAttribute('srcset');
    image.setAttribute('src', previewUrl);

    card.classList.add('is-omo-color-preview');
  };

  const restorePreview = (card) => {
    const image = getMainImage(card);

    if (!card || !image) return;

    const originalSrc = image.dataset.omoOriginalSrc;
    const originalSrcset = image.dataset.omoOriginalSrcset;

    if (originalSrc) {
      image.setAttribute('src', originalSrc);
    }

    if (originalSrcset) {
      image.setAttribute('srcset', originalSrcset);
    }

    card.classList.remove('is-omo-color-preview');
  };


  /*
   * Mouse / pointer hover
   */
  document.addEventListener('pointerover', (event) => {
    const link = event.target.closest(
      '.omo-card-colors__link[data-omo-card-preview-image]'
    );

    if (!link) return;

    if (
      event.relatedTarget &&
      link.contains(event.relatedTarget)
    ) {
      return;
    }

    showPreview(link);
  });


  document.addEventListener('pointerout', (event) => {
    const link = event.target.closest(
      '.omo-card-colors__link[data-omo-card-preview-image]'
    );

    if (!link) return;

    if (
      event.relatedTarget &&
      link.contains(event.relatedTarget)
    ) {
      return;
    }

    const card = getCard(link);

    /*
     * When moving directly from one swatch
     * to another swatch in the same card,
     * don't flash back to the original image.
     */
    const nextLink =
      event.relatedTarget?.closest?.(
        '.omo-card-colors__link[data-omo-card-preview-image]'
      );

    if (
      nextLink &&
      getCard(nextLink) === card
    ) {
      return;
    }

    restorePreview(card);
  });


  /*
   * Keyboard accessibility
   */
  document.addEventListener('focusin', (event) => {
    const link = event.target.closest(
      '.omo-card-colors__link[data-omo-card-preview-image]'
    );

    if (!link) return;

    showPreview(link);
  });


  document.addEventListener('focusout', (event) => {
    const link = event.target.closest(
      '.omo-card-colors__link[data-omo-card-preview-image]'
    );

    if (!link) return;

    const card = getCard(link);

    const nextLink =
      event.relatedTarget?.closest?.(
        '.omo-card-colors__link[data-omo-card-preview-image]'
      );

    if (
      nextLink &&
      getCard(nextLink) === card
    ) {
      return;
    }

    restorePreview(card);
  });



  document.addEventListener('click', (event) => {
    const link = event.target.closest('.omo-card-colors__link');

    if (!link) return;

    event.stopPropagation();
    });
})();